/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

export type StipendActionType =
  (typeof StipendActionType)[keyof typeof StipendActionType];

export const StipendActionType = {
  accept: "accept",
  reject: "reject",
} as const;
